import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    toggleMobileMenu() {
        const siteHeader = this.element.querySelector('#site-header');
        siteHeader.classList.toggle('active');
    }
}
